<div
  (taAncestorScroll)="open = false"
  [taAncestorScrollDisabled]="!open"
  [class.select__selection--invalid]="!valid && showValidation"
  #dropdownAnchor
>
  <!-- selected value -->
  <div>
    <span
      *ngFor="let selectedModel of selectedModels; index as i"
      [ngClass]="i === highlightedSelectionIndex
        ? 'select__selected-chip select__selected-chip-highlighted'
        : 'select__selected-chip'
      "
    >
      <ng-template
        [ngTemplateOutlet]="selectedOptionLayoutTemplate"
        [ngTemplateOutletContext]="{ $implicit: selectedModel, model: selectedModel, myValue: value }"
      >
      </ng-template>

      <ta-icon
        icon="cancel"
        (click)="$event.stopPropagation(); removeSelectedModels(selectedModel)"
        style="cursor: pointer"
      ></ta-icon>
    </span>
  </div>

  <!-- placeholder -->
  <span *ngIf="value.length === 0 && placeholderLayout != null" class="mv--1">
    <ng-template
      [ngTemplateOutlet]="placeholderLayout.templateRef"
    ></ng-template>
  </span>
  <span
    *ngIf="value.length === 0 && placeholderLayout == null && placeholder != null"
    class="select__selected"
  >
    <span class="color--default">{{ placeholder }}</span>
  </span>

  <span
    *ngIf="clearable && value.length > 0"
    (click)="clearValue($event)"
    [className]="selectClasses.clearButton"
    #clearValueButton
  ></span>

  <span class="select__arrow"> <ta-icon icon="down-dir"></ta-icon> </span>
</div>
